import React from "react";

interface IProps {
    children: React.ReactNode;
    color?: string;
    thickness?: string;
}

export const Underline = ({ children, color = "#178BF1", thickness = "15" }: IProps) => {
    return (
        <span style={{ position: "relative", display: "inline-block" }}>
            {/* Texto */}
            <span style={{ zIndex: 1, position: "relative" }}>{children}</span>
            {/* Rabisco */}
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 200 40"
                preserveAspectRatio="none"
                style={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    width: "100%",
                    height: "10px",
                    zIndex: 0,
                }}
            >
                <path
                    d="M200 35 Q150 10, 100 20 T0 35"
                    fill="none"
                    stroke={color}
                    strokeWidth={thickness}
                    strokeLinecap="round"
                />
            </svg>
        </span>
    );
};
